/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2022 (original work) Open Assessment Technologies SA ;
 */

import { __ } from '@oat-sa-private/ui-core';

export default function SpecialCharactersLatinAndMaths(editor) {
    editor.plugins.get('SpecialCharacters').addItems(__('Basic Latin'), [
        { title: __('EXCLAMATION MARK'), character: '!' },
        { title: __('QUOTATION MARK'), character: '"' },
        { title: __('NUMBER SIGN'), character: '#' },
        { title: __('DOLLAR SIGN'), character: '$' },
        { title: __('PERCENT SIGN'), character: '%' },
        { title: __('AMPERSAND'), character: '&' },
        { title: __('APOSTROPHE'), character: "'" },
        { title: __('LEFT PARENTHESIS'), character: '(' },
        { title: __('RIGHT PARENTHESIS'), character: ')' },
        { title: __('ASTERISK'), character: '*' },
        { title: __('PLUS SIGN'), character: '+' },
        { title: __('HYPHEN-MINUS'), character: '-' },
        { title: __('FULL STOP'), character: '.' },
        { title: __('SOLIDUS'), character: '/' },
        { title: __('DIGIT ZERO'), character: '0' },
        { title: __('DIGIT ONE'), character: '1' },
        { title: __('DIGIT TWO'), character: '2' },
        { title: __('DIGIT THREE'), character: '3' },
        { title: __('DIGIT FOUR'), character: '4' },
        { title: __('DIGIT FIVE'), character: '5' },
        { title: __('DIGIT SIX'), character: '6' },
        { title: __('DIGIT SEVEN'), character: '7' },
        { title: __('DIGIT EIGHT'), character: '8' },
        { title: __('DIGIT NINE'), character: '9' },
        { title: __('COLON'), character: ':' },
        { title: __('SEMICOLON'), character: ';' },
        { title: __('LESS-THAN SIGN'), character: '<' },
        { title: __('EQUALS SIGN'), character: '=' },
        { title: __('GREATER-THAN SIGN'), character: '>' },
        { title: __('QUESTION MARK'), character: '?' },
        { title: __('COMMERCIAL AT'), character: '@' },
        { title: __('LATIN CAPITAL LETTER A'), character: 'A' },
        { title: __('LATIN CAPITAL LETTER B'), character: 'B' },
        { title: __('LATIN CAPITAL LETTER C'), character: 'C' },
        { title: __('LATIN CAPITAL LETTER D'), character: 'D' },
        { title: __('LATIN CAPITAL LETTER E'), character: 'E' },
        { title: __('LATIN CAPITAL LETTER F'), character: 'F' },
        { title: __('LATIN CAPITAL LETTER G'), character: 'G' },
        { title: __('LATIN CAPITAL LETTER H'), character: 'H' },
        { title: __('LATIN CAPITAL LETTER I'), character: 'I' },
        { title: __('LATIN CAPITAL LETTER J'), character: 'J' },
        { title: __('LATIN CAPITAL LETTER K'), character: 'K' },
        { title: __('LATIN CAPITAL LETTER L'), character: 'L' },
        { title: __('LATIN CAPITAL LETTER M'), character: 'M' },
        { title: __('LATIN CAPITAL LETTER N'), character: 'N' },
        { title: __('LATIN CAPITAL LETTER O'), character: 'O' },
        { title: __('LATIN CAPITAL LETTER P'), character: 'P' },
        { title: __('LATIN CAPITAL LETTER Q'), character: 'Q' },
        { title: __('LATIN CAPITAL LETTER R'), character: 'R' },
        { title: __('LATIN CAPITAL LETTER S'), character: 'S' },
        { title: __('LATIN CAPITAL LETTER T'), character: 'T' },
        { title: __('LATIN CAPITAL LETTER U'), character: 'U' },
        { title: __('LATIN CAPITAL LETTER V'), character: 'V' },
        { title: __('LATIN CAPITAL LETTER W'), character: 'W' },
        { title: __('LATIN CAPITAL LETTER X'), character: 'X' },
        { title: __('LATIN CAPITAL LETTER Y'), character: 'Y' },
        { title: __('LATIN CAPITAL LETTER Z'), character: 'Z' },
        { title: __('LEFT SQUARE BRACKET'), character: '[' },
        { title: __('RIGHT SQUARE BRACKET'), character: ']' },
        { title: __('CIRCUMFLEX ACCENT'), character: '^' },
        { title: __('LOW LINE'), character: '_' },
        { title: __('GRAVE ACCENT'), character: '`' },
        { title: __('LATIN SMALL LETTER A'), character: 'a' },
        { title: __('LATIN SMALL LETTER B'), character: 'b' },
        { title: __('LATIN SMALL LETTER C'), character: 'c' },
        { title: __('LATIN SMALL LETTER D'), character: 'd' },
        { title: __('LATIN SMALL LETTER E'), character: 'e' },
        { title: __('LATIN SMALL LETTER F'), character: 'f' },
        { title: __('LATIN SMALL LETTER G'), character: 'g' },
        { title: __('LATIN SMALL LETTER H'), character: 'h' },
        { title: __('LATIN SMALL LETTER I'), character: 'i' },
        { title: __('LATIN SMALL LETTER J'), character: 'j' },
        { title: __('LATIN SMALL LETTER K'), character: 'k' },
        { title: __('LATIN SMALL LETTER L'), character: 'l' },
        { title: __('LATIN SMALL LETTER M'), character: 'm' },
        { title: __('LATIN SMALL LETTER N'), character: 'n' },
        { title: __('LATIN SMALL LETTER O'), character: 'o' },
        { title: __('LATIN SMALL LETTER P'), character: 'p' },
        { title: __('LATIN SMALL LETTER Q'), character: 'q' },
        { title: __('LATIN SMALL LETTER R'), character: 'r' },
        { title: __('LATIN SMALL LETTER S'), character: 's' },
        { title: __('LATIN SMALL LETTER T'), character: 't' },
        { title: __('LATIN SMALL LETTER U'), character: 'u' },
        { title: __('LATIN SMALL LETTER V'), character: 'v' },
        { title: __('LATIN SMALL LETTER W'), character: 'w' },
        { title: __('LATIN SMALL LETTER X'), character: 'x' },
        { title: __('LATIN SMALL LETTER Y'), character: 'y' },
        { title: __('LATIN SMALL LETTER Z'), character: 'z' },
        { title: __('LEFT CURLY BRACKET'), character: '{' },
        { title: __('VERTICAL LINE'), character: '|' },
        { title: __('RIGHT CURLY BRACKET'), character: '}' },
        { title: __('TILDE'), character: '~' }
    ]);
    editor.plugins
        .get('SpecialCharacters')
        .addItems(__('Currency Symbols'), [{ title: __('EURO SIGN'), character: '€' }]);
    editor.plugins.get('SpecialCharacters').addItems(__('General Punctuation'), [
        { title: __('LEFT SINGLE QUOTATION MARK'), character: '‘' },
        { title: __('RIGHT SINGLE QUOTATION MARK'), character: '’' },
        { title: __('LEFT DOUBLE QUOTATION MARK'), character: '“' },
        { title: __('RIGHT DOUBLE QUOTATION MARK'), character: '”' },
        { title: __('EN DASH'), character: '–' },
        { title: __('EM DASH'), character: '—' },
        { title: __('SINGLE LOW-9 QUOTATION MARK'), character: '‚' },
        { title: __('SINGLE HIGH-REVERSED-9 QUOTATION MARK'), character: '‛' },
        { title: __('DOUBLE LOW-9 QUOTATION MARK'), character: '„' },
        { title: __('HORIZONTAL ELLIPSIS'), character: '…' },
        { title: __('BULLET'), character: '•' }
    ]);
    editor.plugins.get('SpecialCharacters').addItems(__('Latin-1 Supplement'), [
        { title: __('INVERTED EXCLAMATION MARK'), character: '¡' },
        { title: __('CENT SIGN'), character: '¢' },
        { title: __('POUND SIGN'), character: '£' },
        { title: __('CURRENCY SIGN'), character: '¤' },
        { title: __('YEN SIGN'), character: '¥' },
        { title: __('BROKEN BAR'), character: '¦' },
        { title: __('SECTION SIGN'), character: '§' },
        { title: __('DIAERESIS'), character: '¨' },
        { title: __('COPYRIGHT SIGN'), character: '©' },
        { title: __('FEMININE ORDINAL INDICATOR'), character: 'ª' },
        { title: __('LEFT-POINTING DOUBLE ANGLE QUOTATION MARK'), character: '«' },
        { title: __('NOT SIGN'), character: '¬' },
        { title: __('REGISTERED SIGN'), character: '®' },
        { title: __('MACRON'), character: '¯' },
        { title: __('DEGREE SIGN'), character: '°' },
        { title: __('SUPERSCRIPT TWO'), character: '²' },
        { title: __('SUPERSCRIPT THREE'), character: '³' },
        { title: __('ACUTE ACCENT'), character: '´' },
        { title: __('MICRO SIGN'), character: 'µ' },
        { title: __('PILCROW SIGN'), character: '¶' },
        { title: __('MIDDLE DOT'), character: '·' },
        { title: __('CEDILLA'), character: '¸' },
        { title: __('SUPERSCRIPT ONE'), character: '¹' },
        { title: __('MASCULINE ORDINAL INDICATOR'), character: 'º' },
        { title: __('RIGHT-POINTING DOUBLE ANGLE QUOTATION MARK'), character: '»' },
        { title: __('VULGAR FRACTION ONE QUARTER'), character: '¼' },
        { title: __('VULGAR FRACTION ONE HALF'), character: '½' },
        { title: __('VULGAR FRACTION THREE QUARTERS'), character: '¾' },
        { title: __('INVERTED QUESTION MARK'), character: '¿' },
        { title: __('LATIN CAPITAL LETTER A WITH GRAVE'), character: 'À' },
        { title: __('LATIN CAPITAL LETTER A WITH ACUTE'), character: 'Á' },
        { title: __('LATIN CAPITAL LETTER A WITH CIRCUMFLEX'), character: 'Â' },
        { title: __('LATIN CAPITAL LETTER A WITH TILDE'), character: 'Ã' },
        { title: __('LATIN CAPITAL LETTER A WITH DIAERESIS'), character: 'Ä' },
        { title: __('LATIN CAPITAL LETTER A WITH RING ABOVE'), character: 'Å' },
        { title: __('LATIN CAPITAL LETTER AE'), character: 'Æ' },
        { title: __('LATIN CAPITAL LETTER C WITH CEDILLA'), character: 'Ç' },
        { title: __('LATIN CAPITAL LETTER E WITH GRAVE'), character: 'È' },
        { title: __('LATIN CAPITAL LETTER E WITH ACUTE'), character: 'É' },
        { title: __('LATIN CAPITAL LETTER E WITH CIRCUMFLEX'), character: 'Ê' },
        { title: __('LATIN CAPITAL LETTER E WITH DIAERESIS'), character: 'Ë' },
        { title: __('LATIN CAPITAL LETTER I WITH GRAVE'), character: 'Ì' },
        { title: __('LATIN CAPITAL LETTER I WITH ACUTE'), character: 'Í' },
        { title: __('LATIN CAPITAL LETTER I WITH CIRCUMFLEX'), character: 'Î' },
        { title: __('LATIN CAPITAL LETTER I WITH DIAERESIS'), character: 'Ï' },
        { title: __('LATIN CAPITAL LETTER ETH'), character: 'Ð' },
        { title: __('LATIN CAPITAL LETTER N WITH TILDE'), character: 'Ñ' },
        { title: __('LATIN CAPITAL LETTER O WITH GRAVE'), character: 'Ò' },
        { title: __('LATIN CAPITAL LETTER O WITH ACUTE'), character: 'Ó' },
        { title: __('LATIN CAPITAL LETTER O WITH CIRCUMFLEX'), character: 'Ô' },
        { title: __('LATIN CAPITAL LETTER O WITH TILDE'), character: 'Õ' },
        { title: __('LATIN CAPITAL LETTER O WITH DIAERESIS'), character: 'Ö' },
        { title: __('MULTIPLICATION SIGN'), character: '×' },
        { title: __('LATIN CAPITAL LETTER O WITH STROKE'), character: 'Ø' },
        { title: __('LATIN CAPITAL LETTER U WITH GRAVE'), character: 'Ù' },
        { title: __('LATIN CAPITAL LETTER U WITH ACUTE'), character: 'Ú' },
        { title: __('LATIN CAPITAL LETTER U WITH CIRCUMFLEX'), character: 'Û' },
        { title: __('LATIN CAPITAL LETTER U WITH DIAERESIS'), character: 'Ü' },
        { title: __('LATIN CAPITAL LETTER Y WITH ACUTE'), character: 'Ý' },
        { title: __('LATIN CAPITAL LETTER THORN'), character: 'Þ' },
        { title: __('LATIN SMALL LETTER SHARP S'), character: 'ß' },
        { title: __('LATIN SMALL LETTER A WITH GRAVE'), character: 'à' },
        { title: __('LATIN SMALL LETTER A WITH ACUTE'), character: 'á' },
        { title: __('LATIN SMALL LETTER A WITH CIRCUMFLEX'), character: 'â' },
        { title: __('LATIN SMALL LETTER A WITH TILDE'), character: 'ã' },
        { title: __('LATIN SMALL LETTER A WITH DIAERESIS'), character: 'ä' },
        { title: __('LATIN SMALL LETTER A WITH RING ABOVE'), character: 'å' },
        { title: __('LATIN SMALL LETTER AE'), character: 'æ' },
        { title: __('LATIN SMALL LETTER C WITH CEDILLA'), character: 'ç' },
        { title: __('LATIN SMALL LETTER E WITH GRAVE'), character: 'è' },
        { title: __('LATIN SMALL LETTER E WITH ACUTE'), character: 'é' },
        { title: __('LATIN SMALL LETTER E WITH CIRCUMFLEX'), character: 'ê' },
        { title: __('LATIN SMALL LETTER E WITH DIAERESIS'), character: 'ë' },
        { title: __('LATIN SMALL LETTER I WITH GRAVE'), character: 'ì' },
        { title: __('LATIN SMALL LETTER I WITH ACUTE'), character: 'í' },
        { title: __('LATIN SMALL LETTER I WITH CIRCUMFLEX'), character: 'î' },
        { title: __('LATIN SMALL LETTER I WITH DIAERESIS'), character: 'ï' },
        { title: __('LATIN SMALL LETTER ETH'), character: 'ð' },
        { title: __('LATIN SMALL LETTER N WITH TILDE'), character: 'ñ' },
        { title: __('LATIN SMALL LETTER O WITH GRAVE'), character: 'ò' },
        { title: __('LATIN SMALL LETTER O WITH ACUTE'), character: 'ó' },
        { title: __('LATIN SMALL LETTER O WITH CIRCUMFLEX'), character: 'ô' },
        { title: __('LATIN SMALL LETTER O WITH TILDE'), character: 'õ' },
        { title: __('LATIN SMALL LETTER O WITH DIAERESIS'), character: 'ö' },
        { title: __('DIVISION SIGN'), character: '÷' },
        { title: __('LATIN SMALL LETTER O WITH STROKE'), character: 'ø' },
        { title: __('LATIN SMALL LETTER U WITH GRAVE'), character: 'ù' },
        { title: __('LATIN SMALL LETTER U WITH ACUTE'), character: 'ú' },
        { title: __('LATIN SMALL LETTER U WITH CIRCUMFLEX'), character: 'û' },
        { title: __('LATIN SMALL LETTER U WITH DIAERESIS'), character: 'ü' },
        { title: __('LATIN SMALL LETTER Y WITH ACUTE'), character: 'ý' },
        { title: __('LATIN SMALL LETTER THORN'), character: 'þ' },
        { title: __('LATIN SMALL LETTER Y WITH DIAERESIS'), character: 'ÿ' },
        { title: __('LATIN CAPITAL LETTER A WITH GRAVE'), character: 'À' },
        { title: __('LATIN SMALL LETTER A WITH GRAVE'), character: 'à' },
        { title: __('LATIN CAPITAL LETTER A WITH ACUTE'), character: 'Á' },
        { title: __('LATIN SMALL LETTER A WITH ACUTE'), character: 'á' },
        { title: __('LATIN CAPITAL LETTER A WITH CIRCUMFLEX'), character: 'Â' },
        { title: __('LATIN SMALL LETTER A WITH CIRCUMFLEX'), character: 'â' },
        { title: __('LATIN CAPITAL LETTER A WITH TILDE'), character: 'Ã' },
        { title: __('LATIN SMALL LETTER A WITH TILDE'), character: 'ã' },
        { title: __('LATIN CAPITAL LETTER A WITH DIAERESIS'), character: 'Ä' },
        { title: __('LATIN SMALL LETTER A WITH DIAERESIS'), character: 'ä' },
        { title: __('LATIN CAPITAL LETTER C WITH CEDILLA'), character: 'Ç' },
        { title: __('LATIN SMALL LETTER C WITH CEDILLA'), character: 'ç' },
        { title: __('LATIN SMALL LETTER ETH'), character: 'ð' },
        { title: __('LATIN CAPITAL LETTER E WITH GRAVE'), character: 'È' },
        { title: __('LATIN SMALL LETTER E WITH GRAVE'), character: 'è' },
        { title: __('LATIN CAPITAL LETTER E WITH ACUTE'), character: 'É' },
        { title: __('LATIN SMALL LETTER E WITH ACUTE'), character: 'é' },
        { title: __('LATIN CAPITAL LETTER E WITH CIRCUMFLEX'), character: 'Ê' },
        { title: __('LATIN SMALL LETTER E WITH CIRCUMFLEX'), character: 'ê' },
        { title: __('LATIN CAPITAL LETTER E WITH DIAERESIS'), character: 'Ë' },
        { title: __('LATIN SMALL LETTER E WITH DIAERESIS'), character: 'ë' },
        { title: __('LATIN CAPITAL LETTER I WITH GRAVE'), character: 'Ì' },
        { title: __('LATIN SMALL LETTER I WITH GRAVE'), character: 'ì' },
        { title: __('LATIN CAPITAL LETTER I WITH ACUTE'), character: 'Í' },
        { title: __('LATIN SMALL LETTER I WITH ACUTE'), character: 'í' },
        { title: __('LATIN CAPITAL LETTER I WITH CIRCUMFLEX'), character: 'Î' },
        { title: __('LATIN SMALL LETTER I WITH CIRCUMFLEX'), character: 'î' },
        { title: __('LATIN CAPITAL LETTER I WITH DIAERESIS'), character: 'Ï' },
        { title: __('LATIN SMALL LETTER I WITH DIAERESIS'), character: 'ï' },
        { title: __('LATIN CAPITAL LETTER N WITH TILDE'), character: 'Ñ' },
        { title: __('LATIN SMALL LETTER N WITH TILDE'), character: 'ñ' },
        { title: __('LATIN CAPITAL LETTER O WITH GRAVE'), character: 'Ò' },
        { title: __('LATIN SMALL LETTER O WITH GRAVE'), character: 'ò' },
        { title: __('LATIN CAPITAL LETTER O WITH ACUTE'), character: 'Ó' },
        { title: __('LATIN SMALL LETTER O WITH ACUTE'), character: 'ó' },
        { title: __('LATIN CAPITAL LETTER O WITH CIRCUMFLEX'), character: 'Ô' },
        { title: __('LATIN SMALL LETTER O WITH CIRCUMFLEX'), character: 'ô' },
        { title: __('LATIN CAPITAL LETTER O WITH TILDE'), character: 'Õ' },
        { title: __('LATIN SMALL LETTER O WITH TILDE'), character: 'õ' },
        { title: __('LATIN CAPITAL LETTER O WITH DIAERESIS'), character: 'Ö' },
        { title: __('LATIN SMALL LETTER O WITH DIAERESIS'), character: 'ö' },
        { title: __('LATIN CAPITAL LETTER U WITH GRAVE'), character: 'Ù' },
        { title: __('LATIN SMALL LETTER U WITH GRAVE'), character: 'ù' },
        { title: __('LATIN CAPITAL LETTER U WITH ACUTE'), character: 'Ú' },
        { title: __('LATIN SMALL LETTER U WITH ACUTE'), character: 'ú' },
        { title: __('LATIN CAPITAL LETTER U WITH CIRCUMFLEX'), character: 'Û' },
        { title: __('LATIN SMALL LETTER U WITH CIRCUMFLEX'), character: 'û' },
        { title: __('LATIN CAPITAL LETTER U WITH DIAERESIS'), character: 'Ü' },
        { title: __('LATIN SMALL LETTER U WITH DIAERESIS'), character: 'ü' },
        { title: __('LATIN CAPITAL LETTER Y WITH ACUTE'), character: 'Ý' },
        { title: __('LATIN SMALL LETTER Y WITH ACUTE'), character: 'ý' },
        { title: __('LATIN SMALL LETTER Y WITH DIAERESIS'), character: 'ÿ' },
        { title: __('LATIN CAPITAL LETTER THORN'), character: 'Þ' },
        { title: __('LATIN SMALL LETTER THORN'), character: 'þ' },
        { title: __('LATIN SMALL LETTER SHARP S'), character: 'ß' },
        { title: __('INVERTED QUESTION MARK'), character: '¿' },
        { title: __('INVERTED EXCLAMATION MARK'), character: '¡' }
    ]);
    editor.plugins.get('SpecialCharacters').addItems(__('Latin Extended-A'), [
        { title: __('LATIN CAPITAL LIGATURE OE'), character: 'Œ' },
        { title: __('LATIN SMALL LIGATURE OE'), character: 'œ' },
        { title: __('LATIN CAPITAL LETTER W WITH CIRCUMFLEX'), character: 'Ŵ' },
        { title: __('LATIN CAPITAL LETTER Y WITH CIRCUMFLEX'), character: 'Ŷ' },
        { title: __('LATIN SMALL LETTER W WITH CIRCUMFLEX'), character: 'ŵ' },
        { title: __('LATIN SMALL LETTER Y WITH CIRCUMFLEX'), character: 'ŷ' },
        { title: __('LATIN CAPITAL LETTER A WITH MACRON'), character: 'Ā' },
        { title: __('LATIN SMALL LETTER A WITH MACRON'), character: 'ā' },
        { title: __('LATIN CAPITAL LETTER A WITH BREVE'), character: 'Ă' },
        { title: __('LATIN SMALL LETTER A WITH BREVE'), character: 'ă' },
        { title: __('LATIN CAPITAL LETTER A WITH OGONEK'), character: 'Ą' },
        { title: __('LATIN SMALL LETTER A WITH OGONEK'), character: 'ą' },
        { title: __('LATIN CAPITAL LETTER C WITH ACUTE'), character: 'Ć' },
        { title: __('LATIN SMALL LETTER C WITH ACUTE'), character: 'ć' },
        { title: __('LATIN CAPITAL LETTER C WITH CIRCUMFLEX'), character: 'Ĉ' },
        { title: __('LATIN SMALL LETTER C WITH CIRCUMFLEX'), character: 'ĉ' },
        { title: __('LATIN CAPITAL LETTER C WITH DOT ABOVE'), character: 'Ċ' },
        { title: __('LATIN SMALL LETTER C WITH DOT ABOVE'), character: 'ċ' },
        { title: __('LATIN CAPITAL LETTER C WITH CARON'), character: 'Č' },
        { title: __('LATIN SMALL LETTER C WITH CARON'), character: 'č' },
        { title: __('LATIN CAPITAL LETTER D WITH CARON'), character: 'Ď' },
        { title: __('LATIN SMALL LETTER D WITH CARON'), character: 'ď' },
        { title: __('LATIN CAPITAL LETTER D WITH STROKE'), character: 'Đ' },
        { title: __('LATIN SMALL LETTER D WITH STROKE'), character: 'đ' },
        { title: __('LATIN CAPITAL LETTER E WITH MACRON'), character: 'Ē' },
        { title: __('LATIN SMALL LETTER E WITH MACRON'), character: 'ē' },
        { title: __('LATIN CAPITAL LETTER E WITH BREVE'), character: 'Ĕ' },
        { title: __('LATIN SMALL LETTER E WITH BREVE'), character: 'ĕ' },
        { title: __('LATIN CAPITAL LETTER E WITH DOT ABOVE'), character: 'Ė' },
        { title: __('LATIN SMALL LETTER E WITH DOT ABOVE'), character: 'ė' },
        { title: __('LATIN CAPITAL LETTER E WITH OGONEK'), character: 'Ę' },
        { title: __('LATIN SMALL LETTER E WITH OGONEK'), character: 'ę' },
        { title: __('LATIN CAPITAL LETTER E WITH CARON'), character: 'Ě' },
        { title: __('LATIN SMALL LETTER E WITH CARON'), character: 'ě' },
        { title: __('LATIN CAPITAL LETTER G WITH CIRCUMFLEX'), character: 'Ĝ' },
        { title: __('LATIN SMALL LETTER G WITH CIRCUMFLEX'), character: 'ĝ' },
        { title: __('LATIN CAPITAL LETTER G WITH BREVE'), character: 'Ğ' },
        { title: __('LATIN SMALL LETTER G WITH BREVE'), character: 'ğ' },
        { title: __('LATIN CAPITAL LETTER G WITH DOT ABOVE'), character: 'Ġ' },
        { title: __('LATIN SMALL LETTER G WITH DOT ABOVE'), character: 'ġ' },
        { title: __('LATIN CAPITAL LETTER G WITH CEDILLA'), character: 'Ģ' },
        { title: __('LATIN SMALL LETTER G WITH CEDILLA'), character: 'ģ' },
        { title: __('LATIN CAPITAL LETTER H WITH CIRCUMFLEX'), character: 'Ĥ' },
        { title: __('LATIN SMALL LETTER H WITH CIRCUMFLEX'), character: 'ĥ' },
        { title: __('LATIN CAPITAL LETTER I WITH TILDE'), character: 'Ĩ' },
        { title: __('LATIN SMALL LETTER I WITH TILDE'), character: 'ĩ' },
        { title: __('LATIN CAPITAL LETTER I WITH MACRON'), character: 'Ī' },
        { title: __('LATIN SMALL LETTER I WITH MACRON'), character: 'ī' },
        { title: __('LATIN CAPITAL LETTER I WITH BREVE'), character: 'Ĭ' },
        { title: __('LATIN SMALL LETTER I WITH BREVE'), character: 'ĭ' },
        { title: __('LATIN CAPITAL LETTER I WITH DOT ABOVE'), character: 'İ' },
        { title: __('LATIN SMALL LETTER DOTLESS I'), character: 'ı' },
        { title: __('LATIN CAPITAL LETTER I WITH OGONEK'), character: 'Į' },
        { title: __('LATIN SMALL LETTER I WITH OGONEK'), character: 'į' },
        { title: __('LATIN CAPITAL LETTER K WITH CEDILLA'), character: 'Ķ' },
        { title: __('LATIN SMALL LETTER K WITH CEDILLA'), character: 'ķ' },
        { title: __('LATIN CAPITAL LETTER L WITH STROKE'), character: 'Ł' },
        { title: __('LATIN SMALL LETTER L WITH STROKE'), character: 'ł' },
        { title: __('LATIN CAPITAL LETTER L WITH CEDILLA'), character: 'Ļ' },
        { title: __('LATIN SMALL LETTER L WITH CEDILLA'), character: 'ļ' },
        { title: __('LATIN CAPITAL LETTER N WITH ACUTE'), character: 'Ń' },
        { title: __('LATIN SMALL LETTER N WITH ACUTE'), character: 'ń' },
        { title: __('LATIN CAPITAL LETTER N WITH CARON'), character: 'Ň' },
        { title: __('LATIN SMALL LETTER N WITH CARON'), character: 'ň' },
        { title: __('LATIN CAPITAL LETTER ENG'), character: 'Ŋ' },
        { title: __('LATIN SMALL LETTER ENG'), character: 'ŋ' },
        { title: __('LATIN CAPITAL LETTER N WITH CEDILLA'), character: 'Ņ' },
        { title: __('LATIN SMALL LETTER N WITH CEDILLA'), character: 'ņ' },
        { title: __('LATIN CAPITAL LETTER O WITH MACRON'), character: 'Ō' },
        { title: __('LATIN SMALL LETTER O WITH MACRON'), character: 'ō' },
        { title: __('LATIN CAPITAL LETTER O WITH BREVE'), character: 'Ŏ' },
        { title: __('LATIN SMALL LETTER O WITH BREVE'), character: 'ŏ' },
        { title: __('LATIN CAPITAL LETTER O WITH DOUBLE ACUTE'), character: 'Ő' },
        { title: __('LATIN SMALL LETTER O WITH DOUBLE ACUTE'), character: 'ő' },
        { title: __('LATIN CAPITAL LIGATURE OE'), character: 'Œ' },
        { title: __('LATIN SMALL LIGATURE OE'), character: 'œ' },
        { title: __('LATIN CAPITAL LETTER R WITH ACUTE'), character: 'Ŕ' },
        { title: __('LATIN SMALL LETTER R WITH ACUTE'), character: 'ŕ' },
        { title: __('LATIN CAPITAL LETTER R WITH CARON'), character: 'Ř' },
        { title: __('LATIN SMALL LETTER R WITH CARON'), character: 'ř' },
        { title: __('LATIN CAPITAL LETTER S WITH ACUTE'), character: 'Ś' },
        { title: __('LATIN SMALL LETTER S WITH ACUTE'), character: 'ś' },
        { title: __('LATIN CAPITAL LETTER S WITH CIRCUMFLEX'), character: 'Ŝ' },
        { title: __('LATIN SMALL LETTER S WITH CIRCUMFLEX'), character: 'ŝ' },
        { title: __('LATIN CAPITAL LETTER S WITH CEDILLA'), character: 'Ş' },
        { title: __('LATIN SMALL LETTER S WITH CEDILLA'), character: 'ş' },
        { title: __('LATIN CAPITAL LETTER S WITH CARON'), character: 'Š' },
        { title: __('LATIN SMALL LETTER S WITH CARON'), character: 'š' },
        { title: __('LATIN CAPITAL LETTER T WITH CEDILLA'), character: 'Ţ' },
        { title: __('LATIN SMALL LETTER T WITH CEDILLA'), character: 'ţ' },
        { title: __('LATIN CAPITAL LETTER T WITH CARON'), character: 'Ť' },
        { title: __('LATIN SMALL LETTER T WITH CARON'), character: 'ť' },
        { title: __('LATIN CAPITAL LETTER T WITH STROKE'), character: 'Ŧ' },
        { title: __('LATIN SMALL LETTER T WITH STROKE'), character: 'ŧ' },
        { title: __('LATIN CAPITAL LETTER U WITH TILDE'), character: 'Ũ' },
        { title: __('LATIN SMALL LETTER U WITH TILDE'), character: 'ũ' },
        { title: __('LATIN CAPITAL LETTER U WITH MACRON'), character: 'Ū' },
        { title: __('LATIN SMALL LETTER U WITH MACRON'), character: 'ū' },
        { title: __('LATIN CAPITAL LETTER U WITH BREVE'), character: 'Ŭ' },
        { title: __('LATIN SMALL LETTER U WITH BREVE'), character: 'ŭ' },
        { title: __('LATIN CAPITAL LETTER U WITH DOUBLE ACUTE'), character: 'Ű' },
        { title: __('LATIN SMALL LETTER U WITH DOUBLE ACUTE'), character: 'ű' },
        { title: __('LATIN CAPITAL LETTER U WITH OGONEK'), character: 'Ų' },
        { title: __('LATIN SMALL LETTER U WITH OGONEK'), character: 'ų' },
        { title: __('LATIN CAPITAL LETTER Y WITH DIAERESIS'), character: 'Ÿ' },
        { title: __('LATIN CAPITAL LETTER Y WITH CIRCUMFLEX'), character: 'Ŷ' },
        { title: __('LATIN SMALL LETTER Y WITH CIRCUMFLEX'), character: 'ŷ' },
        { title: __('LATIN CAPITAL LETTER Z WITH ACUTE'), character: 'Ź' },
        { title: __('LATIN SMALL LETTER Z WITH ACUTE'), character: 'ź' },
        { title: __('LATIN CAPITAL LETTER Z WITH DOT ABOVE'), character: 'Ż' },
        { title: __('LATIN SMALL LETTER Z WITH DOT ABOVE'), character: 'ż' },
        { title: __('LATIN CAPITAL LETTER Z WITH CARON'), character: 'Ž' },
        { title: __('LATIN SMALL LETTER Z WITH CARON'), character: 'ž' }
    ]);
    editor.plugins
        .get('SpecialCharacters')
        .addItems(__('Letterlike Symbols'), [{ title: __('TRADE MARK SIGN'), character: '™' }]);
    editor.plugins
        .get('SpecialCharacters')
        .addItems(__('Geometric Shapes'), [{ title: __('BLACK RIGHT-POINTING POINTER'), character: '►' }]);
    editor.plugins.get('SpecialCharacters').addItems(__('Arrows'), [
        { title: __('RIGHTWARDS ARROW'), character: '→' },
        { title: __('RIGHTWARDS DOUBLE ARROW'), character: '⇒' },
        { title: __('LEFT RIGHT DOUBLE ARROW'), character: '⇔' }
    ]);
    editor.plugins
        .get('SpecialCharacters')
        .addItems(__('Miscellaneous Symbols'), [{ title: __('BLACK DIAMOND SUIT'), character: '♦' }]);
    editor.plugins
        .get('SpecialCharacters')
        .addItems(__('Mathematical Operators'), [{ title: __('ALMOST EQUAL TO'), character: '≈' }]);
    editor.plugins
        .get('SpecialCharacters')
        .addItems(__('Greek and Coptic'), [{ title: __('GREEK CAPITAL LETTER OMEGA'), character: 'Ω' }]);
}
